import { useEffect, useState } from 'react';
import {
  getAgencyDefaultCommission,
  subscribeAgencyDefaultCommission,
} from '../services/settingsService';

/**
 * The agency's default commission (0–1), or null until it has loaded.
 * Forms seed a new campaign's commission from it when the creator has no
 * default of their own.
 */
export function useAgencyDefaultCommission(): number | null {
  const [pct, setPct] = useState<number | null>(null);

  useEffect(() => {
    let active = true;
    getAgencyDefaultCommission().then((v) => { if (active) setPct(v); });
    const unsubscribe = subscribeAgencyDefaultCommission((v) => { if (active) setPct(v); });
    return () => { active = false; unsubscribe(); };
  }, []);

  return pct;
}
